(() => {
  const syncVariant = (root, select) => {
    const variant = select.selectedOptions[0];
    const status = root.querySelector('[data-option-status]');
    const button = root.querySelector('[data-add]');
    const price = root.querySelector('.product-price');
    const payment = root.querySelector('.shopify-payment-button');
    const available = !!variant && variant.dataset.available === 'true';
    select.disabled = !variant;
    button.disabled = !available || root.hasAttribute('data-cart-busy') || root.hasAttribute('data-cart-uncertain');
    button.textContent = variant ? (available ? button.dataset.addLabel : button.dataset.soldLabel) : button.dataset.unavailableLabel;
    if (price) price.hidden = !variant;
    if (payment) payment.hidden = !available;
    if (status) {
      status.hidden = available;
      status.textContent = variant ? (available ? '' : status.dataset.sold) : status.dataset.unavailable;
    }
    const selection = root.querySelector('[data-selected-options]');
    if (selection) selection.textContent = variant ? JSON.parse(variant.dataset.options || '[]').join(' / ') : button.dataset.unavailableLabel;
    const url = new URL(location.href);
    if (!variant) {
      url.searchParams.delete('variant');
      history.replaceState({}, '', url);
      return;
    }
    root.querySelector('[data-price]').textContent = variant.dataset.price;
    const compare = root.querySelector('[data-compare]');
    compare.textContent = variant.dataset.compare;
    compare.hidden = !variant.dataset.compare;
    const quantity = root.querySelector('[name="quantity"]');
    quantity.min = variant.dataset.min || 1;
    quantity.step = variant.dataset.step || 1;
    if (variant.dataset.max) quantity.max = variant.dataset.max;
    else quantity.removeAttribute('max');
    quantity.value = quantity.min;
    const image = root.querySelector('#ProductMainImage');
    if (image && variant.dataset.image) {
      image.src = variant.dataset.image;
      image.alt = variant.dataset.alt || '';
      if (variant.dataset.srcset) image.srcset = variant.dataset.srcset;
      else image.removeAttribute('srcset');
    }
    root.querySelectorAll('.thumbs a').forEach(link => {
      if (image && new URL(link.dataset.image, location.href).href === image.src) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });
    root.dispatchEvent(new Event('ridge:variant-change'));
    url.searchParams.set('variant', variant.value);
    history.replaceState({}, '', url);
  };
  document.querySelectorAll('[data-product]').forEach(root => {
    const select = root.querySelector('[data-variant]');
    const controls = root.querySelector('[data-option-controls]');
    if (!select) return;
    const variants = Array.from(select.options).map(option => ({ option, values: JSON.parse(option.dataset.options || '[]') }));
    const refreshOptions = () => {
      if (!controls) return;
      const selectors = Array.from(controls.querySelectorAll('select'));
      selectors.forEach((control, index) => {
        Array.from(control.options).forEach(option => {
          const candidates = variants.filter(variant => variant.values[index] === option.value && selectors.slice(0, index).every((previous, i) => variant.values[i] === previous.value));
          const exists = candidates.length > 0;
          const available = candidates.some(variant => variant.option.dataset.available === 'true');
          option.disabled = !exists;
          option.textContent = option.value + (!exists ? ` — ${controls.dataset.unavailableLabel}` : (!available ? ` — ${controls.dataset.soldLabel}` : ''));
        });
      });
    };
    if (controls && variants.every(variant => variant.values.length > 0)) {
      controls.hidden = false;
      root.querySelector('[data-variant-fallback]').hidden = true;
      controls.addEventListener('change', () => {
        const values = Array.from(controls.querySelectorAll('select')).map(control => control.value);
        const match = variants.find(variant => variant.values.length === values.length && variant.values.every((value, index) => value === values[index]));
        select.selectedIndex = match ? variants.indexOf(match) : -1;
        refreshOptions();
        syncVariant(root, select);
      });
    }
    select.addEventListener('change', () => {
      const selected = variants.find(variant => variant.option === select.selectedOptions[0]);
      if (controls && selected) controls.querySelectorAll('select').forEach((control, index) => { control.value = selected.values[index]; });
      refreshOptions();
      syncVariant(root, select);
    });
    root.addEventListener('click', event => {
      const link = event.target.closest('.thumbs a[data-image]');
      const image = root.querySelector('#ProductMainImage');
      if (!link || !image) return;
      event.preventDefault();
      image.src = link.dataset.image;
      image.alt = link.dataset.alt || '';
      if (link.dataset.srcset) image.srcset = link.dataset.srcset;
      else image.removeAttribute('srcset');
      root.querySelectorAll('.thumbs a').forEach(item => item.removeAttribute('aria-current'));
      link.setAttribute('aria-current', 'true');
    });
    refreshOptions();
    syncVariant(root, select);
  });
})();// Cart feedback: preserve the native form when JavaScript is unavailable.
(() => {
  let cartRevision = 0;
  document.querySelectorAll('[data-product][data-cart-add-url]').forEach(root => {
    const form = root.querySelector('#IronProductForm');
    const button = root.querySelector('[data-add]');
    const feedback = root.querySelector('[data-cart-feedback]');
    const message = root.querySelector('[data-cart-message]');
    const links = root.querySelector('[data-cart-links]');
    if (!form || !button || !feedback || !message || !links || !window.fetch || !window.FormData) return;
    const report = (text, state) => {
      feedback.hidden = false;
      feedback.dataset.state = state;
      message.textContent = text;
      links.hidden = state === 'pending';
    };
    const updateCount = async (data, revision) => {
      const html = data && data.sections && data.sections['ridge-cart-count'];
      let value;
      if (typeof html === 'string') {
        const count = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-count]');
        if (count && /^\d+$/.test(count.textContent.trim())) value = Number(count.textContent.trim());
      }
      if (value === undefined) {
        try {
          const response = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } });
          if (!response.ok) return;
          const cart = await response.json();
          if (!Number.isInteger(cart.item_count) || cart.item_count < 0) return;
          value = cart.item_count;
        } catch (_) { return; }
      }
      if (revision !== cartRevision) return;
      document.querySelectorAll('.cart-count').forEach(node => { node.textContent = String(value); });
    };
    form.addEventListener('submit', async event => {
      if (event.submitter && event.submitter !== button) return;
      event.preventDefault();
      if (root.hasAttribute('data-cart-busy') || root.hasAttribute('data-cart-uncertain') || button.disabled) return;
      if (!form.reportValidity()) return;
      const revision = ++cartRevision;
      const body = new FormData(form);
      body.set('sections', 'ridge-cart-count');
      body.set('sections_url', location.pathname);
      const fields = Array.from(form.querySelectorAll('input, select, textarea, button')).map(node => ({ node, disabled: node.disabled }));
      const payment = root.querySelector('.shopify-payment-button');
      const paymentHidden = payment && payment.hidden;
      root.setAttribute('data-cart-busy', '');
      form.setAttribute('aria-busy', 'true');
      fields.forEach(({ node }) => { node.disabled = true; });
      if (payment) payment.hidden = true;
      button.textContent = feedback.dataset.adding;
      report(feedback.dataset.adding, 'pending');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(root.dataset.cartAddUrl, {
          method: 'POST', headers: { Accept: 'application/json' }, body, signal: controller.signal
        });
        const data = await response.json();
        if (response.ok || response.status === 422) void updateCount(data, revision).catch(() => {});
        if (!response.ok) {
          if (response.status >= 500) throw new Error('Unconfirmed cart update');
          // Inventory errors can partially add stock. Always offer a cart review.
          const detail = typeof data.description === 'string' ? data.description : '';
          report([detail, feedback.dataset.error].filter(Boolean).join(' '), 'error');
        } else if (data && (data.id || (Array.isArray(data.items) && data.items.length))) {
          report(feedback.dataset.added, 'success');
        } else {
          throw new Error('Unconfirmed cart update');
        }
      } catch (_) {
        // Never retry an ambiguous POST automatically: it may already have succeeded.
        root.setAttribute('data-cart-uncertain', '');
        report(feedback.dataset.uncertain, 'error');
      } finally {
        clearTimeout(timer);
        root.removeAttribute('data-cart-busy');
        form.removeAttribute('aria-busy');
        fields.forEach(({ node, disabled }) => { node.disabled = disabled; });
        if (payment) payment.hidden = paymentHidden;
        const variant = root.querySelector('[data-variant]').selectedOptions[0];
        const available = variant && variant.dataset.available === 'true';
        button.disabled = !available || root.hasAttribute('data-cart-uncertain');
        button.textContent = available ? button.dataset.addLabel : (variant ? button.dataset.soldLabel : button.dataset.unavailableLabel);
        root.dispatchEvent(new Event('ridge:variant-change'));
      }
    });
  });
})();
(() => {
  document.querySelectorAll('[data-product]').forEach(root => {
    const quantity = root.querySelector('[name="quantity"]');
    const controls = Array.from(root.querySelectorAll('[data-quantity-change]'));
    if (!quantity || !controls.length) return;
    const refresh = () => {
      const value = Number(quantity.value);
      const minimum = Number(quantity.min || 1);
      const maximum = quantity.max ? Number(quantity.max) : Infinity;
      controls.forEach(button => {
        button.hidden = false;
        button.disabled = quantity.disabled || (Number(button.dataset.quantityChange) < 0 ? value <= minimum : value >= maximum);
      });
    };
    controls.forEach(button => button.addEventListener('click', () => {
      if (quantity.disabled || root.hasAttribute('data-cart-busy')) return;
      if (!quantity.validity.valid) { quantity.reportValidity(); return; }
      if (Number(button.dataset.quantityChange) < 0) quantity.stepDown();
      else quantity.stepUp();
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
    }));
    quantity.addEventListener('input', refresh);
    quantity.addEventListener('change', refresh);
    root.addEventListener('ridge:variant-change', refresh);
    refresh();
  });
})();
(() => {
  document.querySelectorAll('[data-product]').forEach(root => {
    const image = root.querySelector('#ProductMainImage');
    const trigger = root.querySelector('[data-image-open]');
    const dialog = root.querySelector('[data-image-dialog]');
    const content = root.querySelector('[data-image-content]');
    if (!image || !trigger || !dialog || !content || typeof dialog.showModal !== 'function') return;
    const sync = () => { trigger.href = image.src; };
    root.addEventListener('ridge:variant-change', sync);
    root.addEventListener('click', event => { if (event.target.closest('.thumbs a')) sync(); });
    trigger.addEventListener('click', event => {
      event.preventDefault();
      const detail = document.createElement('img');
      detail.src = image.src;
      detail.alt = image.alt;
      detail.decoding = 'async';
      content.replaceChildren(detail);
      dialog.showModal();
    });
    dialog.querySelector('[data-image-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const box = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => { content.replaceChildren(); trigger.focus(); });
    sync();
  });
})();

